/**
 * Proofing Flow Configuration
 *
 * The flow is now DYNAMIC — no static configuration.
 * Flow structure is derived from requirement templates in the database.
 */

import type { ProductRequirement } from "./types";

/**
 * Get localized label for a product requirement
 */
export function getProductRequirementLabel(
  requirement: ProductRequirement,
  locale: string = "en",
): string {
  return (
    requirement.labels[locale] ||
    requirement.labels.en ||
    requirement.description
  );
}

/**
 * Sort product requirements by order
 */
export function sortProductRequirements(
  requirements: ProductRequirement[],
): ProductRequirement[] {
  return [...requirements].sort((a, b) => a.order - b.order);
}
